import { createContext, useReducer } from "react";

const EditCustomCardContext = createContext({});

const initialState = {
  dugoutEdited: false,
  lineupEdited: false,
  dugoutCardInfo: {
    title: "",
    venue: "",
    city: "",
    state: "",
    homeTeamName: "",
    awayTeamName: "",
    outerColorC: "",
    outerColorM: "",
    outerColorY: "",
    outerColorK: "",
    innerColorC: "",
    innerColorM: "",
    innerColorY: "",
    innerColorK: "",
    showGameDateText: false,
    showGameTimeText: false,
    imageOpacity: 50,
    layout: null,
    headerLogo: null,
    headerLogoFileName: null,
    primaryLogo: null,
    primaryLogoFileName: null,
    homeTeamLogo: null,
    homeTeamLogoFileName: null,
    awayTeamLogo: null,
    awayTeamLogoFileName: null,
  },
  lineupCardInfo: {
    homeTeam: "",
    awayTeam: "",
    gameDate: "",
    homeTeamLogo: null,
    homeTeamFileName: null,
    awayTeamLogo: null,
    awayTeamFileName: null,
  },
};

const EditCustomCardContextProvider = ({ children }) => {
  const reducer = (state, action) => {
    switch (action.type) {
      case "setDugoutCardInfo":
        return { ...state, dugoutCardInfo: action.dugoutCardInfo };
      case "setDugoutTitle":
        return { ...state, dugoutEdited: true, dugoutCardInfo: { ...state.dugoutCardInfo, title: action.title } };
      case "setDugoutVenue":
        return { ...state, dugoutEdited: true, dugoutCardInfo: { ...state.dugoutCardInfo, venue: action.venue } };
      case "setDugoutCity":
        return { ...state, dugoutEdited: true, dugoutCardInfo: { ...state.dugoutCardInfo, city: action.city } };
      case "setDugoutState":
        return { ...state, dugoutEdited: true, dugoutCardInfo: { ...state.dugoutCardInfo, state: action.state } };
      case "setDugoutHomeTeam":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, homeTeamName: action.homeTeam },
        };
      case "setDugoutAwayTeam":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, awayTeamName: action.awayTeam },
        };
      case "setDugoutOutsideBorderC":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, outerColorC: action.outerColorC },
        };
      case "setDugoutOutsideBorderM":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, outerColorM: action.outerColorM },
        };
      case "setDugoutOutsideBorderY":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, outerColorY: action.outerColorY },
        };
      case "setDugoutOutsideBorderK":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, outerColorK: action.outerColorK },
        };
      case "setDugoutInsideBorderC":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, innerColorC: action.innerColorC },
        };
      case "setDugoutInsideBorderM":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, innerColorM: action.innerColorM },
        };
      case "setDugoutInsideBorderY":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, innerColorY: action.innerColorY },
        };
      case "setDugoutInsideBorderK":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, innerColorK: action.innerColorK },
        };
      case "setDugoutGameDate":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, showGameDateText: action.checked },
        };
      case "setDugoutGameTime":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, showGameTimeText: action.checked },
        };
      case "setDugoutImageOpacity":
        return {
          ...state,
          dugoutEdited: true,
          dugoutCardInfo: { ...state.dugoutCardInfo, imageOpacity: action.imageOpacity },
        };
      case "setDugoutHeaderLogo":
        return {
          ...state,
          dugoutEdited: action.dugoutEdited,
          dugoutCardInfo: { ...state.dugoutCardInfo, headerLogo: action.headerLogo },
        };
      case "setDugoutPrimaryLogo":
        return {
          ...state,
          dugoutEdited: action.dugoutEdited,
          dugoutCardInfo: { ...state.dugoutCardInfo, primaryLogo: action.primaryLogo },
        };
      case "setDugoutHomeTeamLogo":
        return {
          ...state,
          dugoutEdited: action.dugoutEdited,
          dugoutCardInfo: { ...state.dugoutCardInfo, homeTeamLogo: action.homeTeamLogo },
        };
      case "setDugoutAwayTeamLogo":
        return {
          ...state,
          dugoutEdited: action.dugoutEdited,
          dugoutCardInfo: { ...state.dugoutCardInfo, awayTeamLogo: action.awayTeamLogo },
        };
      case "setDugoutLayout":
        return { ...state, dugoutEdited: true, dugoutCardInfo: { ...state.dugoutCardInfo, layout: action.layout } };
      case "setLineupCardInfo":
        return { ...state, lineupEdited: false, lineupCardInfo: action.lineupCardInfo };
      case "setLineupHomeTeam":
        return {
          ...state,
          lineupEdited: true,
          lineupCardInfo: { ...state.lineupCardInfo, homeTeam: action.homeTeam },
        };
      case "setLineupAwayTeam":
        return {
          ...state,
          lineupEdited: true,
          lineupCardInfo: { ...state.lineupCardInfo, awayTeam: action.awayTeam },
        };
      case "setLineupDate":
        return { ...state, lineupEdited: true, lineupCardInfo: { ...state.lineupCardInfo, gameDate: action.gameDate } };
      case "setLineupHomeTeamLogo":
        return {
          ...state,
          lineupEdited: action.lineupEdited,
          lineupCardInfo: { ...state.lineupCardInfo, homeTeamLogo: action.homeTeamLogo },
        };
      case "setLineupAwayTeamLogo":
        return {
          ...state,
          lineupEdited: action.lineupEdited,
          lineupCardInfo: { ...state.lineupCardInfo, awayTeamLogo: action.awayTeamLogo },
        };
      case "setLineupEdited":
        return { ...state, lineupEdited: action.lineupEdited };
      case "resetState":
        return initialState;
      case "setCustomCardInfo":
        return { ...state, dugoutCardInfo: action.customCardInfo };
      default:
        return { ...state };
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  return <EditCustomCardContext.Provider value={{ state, dispatch }}>{children}</EditCustomCardContext.Provider>;
};

export { EditCustomCardContext, EditCustomCardContextProvider };
